import React from 'react';
var FlechaArriba = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18" },
        React.createElement("g", { id: "vuesax_linear_arrow-down", "data-name": "vuesax/linear/arrow-down", transform: "translate(0.5 0.5)" },
            React.createElement("g", { id: "arrow-down" },
                React.createElement("path", { id: "Vector", d: "M11.22,0,6.6,4.618a1.407,1.407,0,0,1-1.983,0L0,0", transform: "translate(2.89 6.34)", fill: "none", stroke: "var(--icon-primary-dark)", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", strokeWidth: "1.5", strokeDasharray: "0 0" }),
                React.createElement("path", { id: "Vector-2", "data-name": "Vector", d: "M17,0V17H0V0Z", transform: "translate(17 17) rotate(180)", fill: "none", stroke: "var(--icon-primary-dark)", strokeWidth: "1", opacity: "0" })))));
};
FlechaArriba.defaultProps = {
    className: '',
};
export default FlechaArriba;
